import React, { useEffect} from "react";
import { Card } from "antd";
import { connect } from "react-redux";
import { getEmployeeRewardDashboard } from "../../../../../redux/employeereward/employeeRewardState";
import { Coins, Gift, Users } from "lucide-react";



const AwardCreditSummaryCard = ({ dashboardStats, getDashboard }) => {

  useEffect(() => {
    getDashboard();
  }, [getDashboard]);

  const rewardStatus =
  [  
    {
      title: "Company Balance",
      icon: Coins,
      count: dashboardStats?.company_balance || 0,
      color: "emerald-white",
    },
    {
      title: "Credits Awarded (Month)",
      icon: Gift,
      count: dashboardStats?.credits_awarded_month || 0,
      color: "purple-white",
    },
    {
      title: "Team Members Rewarded",
      icon: Users,
      count: dashboardStats?.team_members_rewarded_month || 0,
      color: "blue-white",
    },

  ];
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {rewardStatus.map((item) => {
        const Icon = item.icon;
        return(
          <Card
            key={item.id}
            className={`rounded-xl card-border-s ${item.color}`}
          >
            <div className="flex items-center justify-between"> 
              <div>
                <p className="text-[12px] title-text mb-1">{item.title}</p>
                <p className="text-[24px] font-semibold card-text">{item.count.toLocaleString()}</p>
              </div>
              <div className="icon-theme p-3 rounded-xl">
                <Icon className="w-6 h-6" />
              </div>
            </div>
          </Card>   
        );
      })}
    </div>
  );
};


const mapStateToProps = (state) => ({
  dashboardStats: state.employeeReward.dashboardStats?.data,
});

const mapDispatchToProps = (dispatch) => ({
  getDashboard: () => dispatch(getEmployeeRewardDashboard()),
  
});

export default connect(mapStateToProps, mapDispatchToProps)(AwardCreditSummaryCard);
